import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import Header from "../../layout/Header/Header";
import { MenuCard, MenuHeader, MenuSection } from "../../MenuCard";

// Las tres vistas de seguimiento juntas: el reporte que cruza todo el proceso
// y los dos checklists de produccion que lo alimentan.
const ITEMS = [
  { type: "section", label: "Reporte" },
  { label: "Seguimiento General", icon: "fas fa-table", color: "#6366f1", bg: "#eef2ff", href: "/SeguimientoGeneral", desc: "Compra, embarque y entrega por modelo", perm: "menu_reportes" },
  { type: "section", label: "Produccion" },
  { label: "Tracking Mexico", icon: "fas fa-clipboard-check", color: "#0ea5e9", bg: "#f0f9ff", href: "/SeguimientoMX", desc: "Checklist de OC: etiquetas, ficha, GS1, FOB", perm: "menu_procesos" },
  { label: "Tracking China", icon: "fas fa-globe-asia", color: "#f43f5e", bg: "#fff1f2", href: "/SeguimientoChina", desc: "Checklist por modelo: muestras, tags, contenedor", perm: "menu_procesos" },
];

function BotonesSeguimientos() {
  const { user } = useContext(AuthContext);
  const puede = !!user.menu_reportes || !!user.menu_procesos || !!user.menu_ventas;
  return (
    <>
      <Header />
      <div className="card container">
        <MenuHeader icon="fas fa-route" color="#6366f1" bg="#eef2ff" title="Seguimientos" subtitle="Del pedido al embarque y a la entrega" />
        {puede ? (
          <div className="row">
            {ITEMS.map((r, i) =>
              r.type === "section"
                ? <MenuSection key={i} title={r.label} />
                : <MenuCard key={i} {...r} enabled={!!user[r.perm]} />
            )}
          </div>
        ) : <p style={{ color: "#94a3b8", fontSize: "0.82rem" }}>Sin acceso.</p>}
      </div>
    </>
  );
}

export default BotonesSeguimientos;
